RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment, formatter) {

    'use strict';

    views.Sidebar = Marionette.LayoutView.extend({
        ui: {
            impersonatingBadge: '#impersonation-badge',
            sharedLandscapeBadge: '#shared-landscape-badge',
            appLogoImg: '#app-logo'
        },
        events: {
            'click .x-force-reg': 'forceRegular',
            'click .x-force-deep': 'forceDeep',
            'click .x-force-finder': 'forceFinder',
            'click .x-beta-toggle': 'toggleBeta',
            'click .x-debug-info': 'showDebugInfo',
            'click .x-page-crash': 'forcePageCrash',
            'click #sidebar-backdrop': 'closeMenu',
            'click .sidebar-footer a': 'onFooterLinkClick',
            'click a': 'closeMenu'
        },

        eventsNotToDebounce: {
            'mouseenter': 'onMouseEnter',
            'mouseleave': 'onMouseLeave',
            'mousewheel #sections-region': 'onScroll'
        },

        regions: {
            landscapeDropdown: '#landscapeDropdown',
            sections: '#sections-region',
            downloads: '#downloads-link'
        },
        className: 'sidebar',
        template: '#shellSidebarTemplate',
        templateHelpers: function () {

            const result = {
                isReadOnly: RivalIQ.state.user.isReadOnly(),
                daysRemainingInTrial: function () {
                    return formatter.formatLabeledNumber('day', 'days', RivalIQ.state.account.getDaysRemainingInTrial());
                },
                appLogoPath: RivalIQ.state.account.get('appLogoPath')
            };

            return result;
        },
        onBeforeShow: function () {

            const me = this;
            me.showSections();
            me.showLandscapeDropdown();
            me.showDownloads();

            if (RivalIQ.state.view.get('isImpersonating')) {
                if (RivalIQ.state.plan.get('has_quid_compete_branding')) {
                    me.ui.impersonatingBadge.addClass('quid');
                }
                me.ui.impersonatingBadge.show();
                me.ui.appLogoImg.addClass('impersonating');
            }

            me.listenTo(RivalIQ.state.account, 'change:user', me.onUserChange);
            me.onUserChange();

            if (RivalIQ.state.account.trialExpired()) {
                const target = me.$el.find('.trial-enabled:first');
                target.popover({
                    container: 'body',
                    placement: 'right',
                    content: 'Get all your valuable metrics and insights by subscribing to a paid plan now!'
                });
            }
        },

        showDownloads: function () {
            const me = this;

            // read-only users don't have downloads link in sidenav
            if (!RivalIQ.state.user.isReadOnly()) {
                me.downloads.show(new views.Downloads({
                    collection: RivalIQ.state.user.get('pendingDownloads')
                }));
            }
        },

        onUserChange: function () {
            const me = this;

            if (!RivalIQ.state.user.isReadOnly() && RivalIQ.state.user.isActive()) {
                RivalIQ.state.account.getUsers().done(function (users) {
                    const dependentUsers = users.filter(function (user) {
                        const readonlySettings = user.get('readonly_settings');
                        return _.get(readonlySettings, 'landscape_id') === RivalIQ.state.landscape.id;
                    });

                    if (_.size(dependentUsers) > 0) {
                        if (RivalIQ.state.plan.get('has_quid_compete_branding')) {
                            me.ui.sharedLandscapeBadge.addClass('quid');
                        }
                        me.ui.sharedLandscapeBadge.show();
                    } else {
                        me.ui.sharedLandscapeBadge.hide();
                    }
                });
            }
        },

        // Stop the body from scrolling when we hit the top or bottom of the
        // sidebar scroll region
        onScroll: function (e) {
            const me = this;
            const $sections = me.sections.$el;
            const scrollTop = $sections.scrollTop();

            if (e.deltaY > 0 && scrollTop === 0 ||
                e.deltaY < 0 && scrollTop === (me.sections.el.scrollHeight - $sections.outerHeight())) {

                e.preventDefault();
            }
        },

        onMouseEnter: function () {
            const me = this;
            me.$el.find('.trial-enabled:first').popover('show');
        },

        onMouseLeave: function () {
            const me = this;
            me.$el.find('.trial-enabled:first').popover('hide');
        },

        closeMenu: function (e) {
            if (e && $(e.target).hasClass('panel-title')) {
                return;
            }
            // TODO figure out a way not to have to reach out?
            $('#application').removeClass('toggled');
            $('body').removeClass('no-scroll');
        },

        onFooterLinkClick: function () {
            const me = this;

            me.model.get('items').each(function (item) {
                item.set('activeModel', null);
            });
        },

        showSections: function () {

            const me = this;

            const view = new views.Sections({
                id: 'sidebar-sections',
                collection: me.model.get('items')
            });

            me.sections.show(view);
        },

        showLandscapeDropdown: function () {
            const me = this;
            me.landscapeDropdown.show(new views.LandscapeDropdown());
        },

        activateChildByFilter: function (filter) {
            const me = this;

            const sections = me.sections.currentView;
            if (sections) {
                sections.collection.each(function activate(item) {
                    let attributes = item;
                    if (item instanceof Backbone.Model) {
                        attributes = item.attributes;
                    }

                    attributes.active = Boolean(filter(attributes));
                    delete attributes.expanded;

                    _.each(attributes.items, activate);
                });

                sections.render();
            }
        },

        activateChildById: function (id) {
            const me = this;
            me.activateChildByFilter((item) => _.get(item, ['id']) === id);
        },

        activateChildByUrl: function (url) {
            const me = this;
            me.activateChildByFilter((item) => _.get(item, ['navigation', 'url']) === url);
        },

        toggleBeta: function (e) {
            const data = $(e.currentTarget).data();
            RivalIQ.state.account.toggleBeta(data.beta, data.enable).done(function () {
                window.location.reload();
            });
        },

        forceRegular: function () {

            $.ajax({
                url: '/admin/updateAllExternalDataCurrentLandscape/true',
                success: function () {
                    RivalIQ.execute('alert:info', 'Landscape update requested');
                },
                error: function () {
                    RivalIQ.execute('alert:danger', 'Something went wrong!');
                }
            });
        },

        forceDeep: function () {

            $.ajax({
                url: '/admin/pullAllAvailableHistoryCurrentLandscape',
                success: function () {
                    RivalIQ.execute('alert:info', 'Landscape history pull requested');
                },
                error: function () {
                    RivalIQ.execute('alert:danger', 'Something went wrong!');
                }
            });
        },

        forceFinder: function () {

            $.ajax({
                url: '/admin/findNewChannelsCurrentLandscape/0/true',
                success: function () {
                    RivalIQ.execute('alert:info', 'Landscape full channel finder run requested');
                },
                error: function () {
                    RivalIQ.execute('alert:danger', 'Something went wrong!');
                }
            });
        },

        showDebugInfo: function () {
            const bugStateMarkdown = RivalIQ.admin.getBugStateMarkdown();
            RivalIQ.execute('show:modal', {
                information: {
                    title: 'Bug State'
                },
                contentHtml: $.tagHtml('pre', {
                    text: bugStateMarkdown
                }),
                actions: [
                    {
                        html: 'Cancel',
                        className: 'btn btn-default',
                        attributes: {
                            type: 'button',
                            'data-dismiss': 'modal'
                        }
                    },
                    {
                        html: 'Copy to Clipboard',
                        className: 'btn btn-info',
                        events: {
                            click: function () {
                                navigator.clipboard.writeText(bugStateMarkdown).then(function () {
                                    RivalIQ.execute('alert:info', 'Debug Info copied to Clipboard');
                                }, function (err) {
                                    RivalIQ.execute('alert:warning', 'Debug Info could not be copied to Clipboard');
                                });
                            }
                        },
                        attributes: {
                            type: 'button'
                        }
                    }
                ]
            });
        },

        forcePageCrash: function () {
            // NOTE intentional bug, to exercise our error reporting
            const obj = null;
            return obj.prop;
        }

    });

}, window.moment, RivalIQ.formatter);
